import axios from "axios";

export const mapDefaultLeaderboardFilter = (value) => {
  if (value === "seasonal") return "yearly";
  return "monthly";
};

export const getUserAppConfiguration = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getapp-config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message);
    }
    throw new Error(error.message);
  }
};

export const getAppConfiguration = async (

  token,
) => {
  try {

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/app-config/get`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(error.message);
    }
  }
};


export const saveAppConfiguration = async (

  token,
  data
) => {
  try {

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/app-config/save`,data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(error.message);
    }
  }
};

